import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { isFor, notFor, outcomes } from "../../data/program";
export function Outcomes() {
  return <section className="border-t border-line bg-coal" data-id="element-154" data-mp="2zokii1ou7t9v">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-6 md:py-28" data-id="element-155" data-mp="2vq50kc7m5b3b">
        <h2 className="max-w-3xl font-display text-4xl font-black uppercase leading-none md:text-5xl" data-id="element-156" data-mp="2qq8v08j9pbln">¿Qué quiero que consigas con CLARIFY?</h2>
        <p className="mt-6 text-lg text-paper/70" data-id="element-157" data-mp="3neyge8u3smcd">
          No quiero que termines diciendo: <span className="text-paper line-through decoration-mute" data-id="element-158" data-mp="3jfpkaxblccdn">“Aprendí a hacer un PDF.”</span>
        </p>
        <p className="mt-2 text-lg text-paper/70" data-id="element-159" data-mp="3ee9xp0trlxt5">Quiero que puedas decir:</p>
        <ul className="mt-10 grid gap-x-10 gap-y-5 sm:grid-cols-2" data-id="element-160" data-mp="39h9qunp3cr0z">
          {outcomes.map(o => <li key={o} className="font-display text-xl font-bold md:text-3xl" data-id="element-161" data-mp="230o8xgrthy85">“{o}”</li>)}
        </ul>
        <p className="mt-12 max-w-2xl text-xl leading-relaxed text-paper/80" data-id="element-162" data-mp="1y0jtlu2nb9ji">
          Porque ahí es cuando dejas de tener simplemente un producto… <span className="font-semibold text-accent" data-id="element-163" data-mp="4fhqpvi6dw07">y empiezas a tener un negocio.</span>
        </p>

        <div className="mt-16 md:mt-24" data-id="element-164" data-mp="8gl1i3ld91uk">
          <h2 className="font-display text-4xl font-black uppercase leading-none md:text-5xl" data-id="element-165" data-mp="3qnha4uqnfhyr">Esto no es para todo el mundo.</h2>
          <div className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-166" data-mp="3vlsjz5gy1sgz">
            <div className="rounded-2xl border border-line p-6 md:p-8" data-id="element-167" data-mp="3gyh812guo6gc">
              <p className="text-lg text-paper/70" data-id="element-168" data-mp="3lpfruc11rmoc">CLARIFY no es para quien busca:</p>
              <ul className="mt-6 space-y-4" data-id="element-169" data-mp="3lrafhy3pdsw4">
                {notFor.map(n => <li key={n} className="flex items-center gap-3 text-xl text-paper/60" data-id="element-170" data-mp="37vy8ar8d29yb">
                    <XIcon className="h-5 w-5 shrink-0 text-mute" aria-hidden data-id="element-171" data-mp="3cxduimm9ymia" /> {n}
                  </li>)}
              </ul>
            </div>
            <div className="rounded-2xl border border-accent/60 p-6 md:p-8" data-id="element-172" data-mp="32z7s83wk3ecw">
              <p className="text-lg text-paper/70" data-id="element-173" data-mp="2ju2zwk9c04yb">CLARIFY es para quien está dispuesto a:</p>
              <ul className="mt-6 space-y-4" data-id="element-174" data-mp="2f3mn92dc4nd0">
                {isFor.map(n => <li key={n} className="flex items-center gap-3 text-xl font-semibold" data-id="element-175" data-mp="2f1s0rjmf0n6t">
                    <CheckIcon className="h-5 w-5 shrink-0 text-accent" aria-hidden data-id="element-176" data-mp="2a2fep13dbk5a" /> {n}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}